import React from "react";
import Style from "./filterButton.module.scss";

const FilterButton = ({ onClick, filterCount = 0, className = "", label = "Filter" }) => {
  return (
    <div className={Style.filter_btn_wrap}>
      <button
        className={`pro-btn pro-btn-outline pro-h-100 pro-px-5 ${className}`}
        onClick={onClick}
      >
        <span className="material-symbols-outlined">tune</span>
        <span>{label}</span>
      </button>
      {filterCount > 0 && (
        <span className={Style.filter_badge}>{filterCount}</span>
      )}
    </div>
  );
};

export default FilterButton;
